import type {ColumnConfig} from 'schema/table/types';

export const bulkUpdateDefaultColumns: ColumnConfig[] = [
  {
    name: 'field',
    width: 150,
  },
];
